export default class Model {
    static _routes = null
    static _routeKey = null
    static _attributes = {}
    tail = {}
    tailIgnore = []
    _tailIgnore = [
        '_tailIgnore',
        'tailIgnore',
        'tail',
        'vue',
        'created_at',
        'updated_at',
        'id',
        'created_by_user_id',
        'belongs_id',
        'belongs_type',
        '$help',
        '$log',
        'user_id',
        'publishedStates',
        'unit_id'
    ]

    constructor(lead, options = {}) {
        if (lead != null) {
            for (let key of Object.keys(lead)) {
                this[key] = lead[key]
            }
        } else {
            // console.log(
            //     this.constructor.name.toLowerCase() +
            //         ' initialzed with no data',
            //     lead,
            // )
            // console.trace(lead)
            // return null
        }

        for (let key of Object.keys(options)) {
            this[key] = options[key]
        }

        if (this._constructor) {
            this._constructor()
        }

        return this
    }

    _updateFromRes(data) {
        for (let key of Object.keys(data)) {
            this[key] = data[key]
        }
    }

    static fill(data, options = {}) {
        for (let i = 0; i < data.length; i++) {
            data[i] = new this(data[i], options)
        }

        return data
    }

    static form(model = null) {
        let tmp = { ...this._attributes }

        for (let key in tmp) {
            if (model != null && model[key] != null) {
                tmp[key] =
                    typeof model[key] == 'function'
                        ? model[key](model)
                        : model[key]
            }

            if (typeof tmp[key] == 'function') {
                tmp[key] = tmp[key](model)
            }
        }

        return tmp
    }

    static route(key, id = null) {
        if (
            this._routes == null ||
            this._routes[key] == undefined
        ) {
            let model = this.name.toLowerCase()

            if (this._routeKey != null) {
                model = this._routeKey
            }

            switch (key) {
                case 'index':
                    return '/' + model + 's'
                    break
                case 'create':
                    return '/' + model
                    break
                default:
                    return '/' + model + '/' + id
                    break
            }
        }

        return this._routes[key]
    }

    set(lead) {
        for (let key of Object.keys(lead)) {
            this[key] = lead[key]
        }
    }

    setHelp(help) {
        this.$help = help

        return this
    }

    aiValidate() {
        return false
    }

    _timeline(user) {
        let contact =
            this.belongs?.contact != undefined
                ? this.belongs.contact
                : this.belongs

        return {
            user:
                this.created_by_user_id == user.id
                    ? 'You'
                    : user.fullName(),
            contact: contact,
        }
    }

    format(key, def = null) {
        if (key == undefined) {
            return [null, null]
        }

        try {
            return this.tail[key] != undefined
                ? this.tail[key]()
                : [key.replace(/_/g, ' '), this[key]]
        } catch (e) {
            console.error(e)
            console.log(key)
        }
    }

    tailIgnoreKeys() {
        return [...this._tailIgnore, ...this.tailIgnore]
    }

    me() {
        return this.constructor._routeKey.toLowerCase()
    }
}
